import React from 'react';

const MessagePopup = ({
  showMessagePopup,
  message,
  setShowMessagePopup
}) => {
  if (!showMessagePopup || !message) return null;

  const isSuccess = message.includes('') || message.includes('successful') || message.includes('activated');
  const isWarning = message.includes('') || message.includes('warning');

  return (
    <div className="modal-overlay" onClick={() => setShowMessagePopup(false)}>
      <div className="message-popup-modal" onClick={(e) => e.stopPropagation()}>
        <button
          className="modal-close-btn"
          onClick={() => setShowMessagePopup(false)}
        >
          ×
        </button>

        <div className="message-popup-content">
          <div className={`message-icon ${isSuccess ? 'success' : isWarning ? 'warning' : 'error'}`}>
          
          </div>

          <div className="message-text">
            {message}
          </div>

          <button
            className="btn-primary message-ok-btn"
            onClick={() => setShowMessagePopup(false)}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default MessagePopup;
